export default __webpack_public_path__ + "static/media/Watch.92ee1330.jpg";